// import _ from 'lodash'

import { BaseModule } from '@vzmi/component_ec_nodejs_util'
import { Error } from '../components/Common/StatePage'

export default class SPBaseModule extends BaseModule {
  /** Override BaseModule loading to disable it */
  renderLoading () {
    return null
  }

  renderIOError () {
    return (
      <Error
        onClick={this.componentDidMount.bind(this)}
        iconType='update'
        text={this.state.msg || '系統忙碌中，請稍後再試'}
      />
    )
  }

  renderError () {
    return (
      <Error
        onClick={this.componentDidMount.bind(this)}
        iconType='attention'
        text={'發生未知錯誤，請稍後再試。'}
      />
    )
  }
}
